<template>
  <div class="pb-5">
    <div class="header-wrapper pt-5">
      <div class="container homebase-container">
        <div class="pb-4">
          <div><back-to-home-button /></div>
        </div>
        <div><h1>Bookmarks</h1></div>
        <div class="page-description row">
          <div class="col-lg-10 col-12">
            <div class="pb-2">
              View all the pages you bookmarked on Autodesk One and followed on
              SharePoint here in one place.
            </div>
            <ul>
              <li>
                <strong>Pinned links</strong> will be prioritized to appear on
                your Autodesk One home page for easy access. You can pin up to 6
                bookmarks by clicking the thumbtack icon below.
              </li>
              <li>
                Click <strong>Recommended bookmarks</strong> to view links suggested
                based on your role, location, or other job attributes specific
                to you.
              </li>
            </ul>
          </div>
        </div>

        <!-- hamburger menu button -->
        <button
          class="d-block d-lg-none"
          type="button"
          data-toggle="collapse"
          data-target="#bookmarks-navbar"
          aria-controls="bookmarks-navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <img
            src="@/assets/image/hamburger_menu_icon.svg"
            alt="hamburger-dropdown"
          />
        </button>

        <nav class="navbar navbar-expand-lg pt-3 px-0 pb-0">
          <div class="collapse navbar-collapse" id="bookmarks-navbar">
            <ul class="navbar-nav">
              <li
                class="nav-item px-4 py-2 d-block"
                v-for="(navTab, i) in navTabs"
                :key="i"
                @click="updateNavTab(i)"
              >
                <a :class="{ active: isTabActive(i) }">{{ navTab.title }}</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <div class="container homebase-container nav-wrapper">
      <!-- nav tabs -->
      <div v-if="navTabs[currentTabIndex].component">
        <component
          :is="navTabs[currentTabIndex].component"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

import BackToHomeButton from "@/components/homebase/buttons/BackToHomeButton";
import BookmarksTable from "@/components/homebase/bookmarks/BookmarksTable";
import RecommendedLinks from "@/components/homebase/bookmarks/RecommendedLinks";

export default {
  name: "autodesk-one-bookmarks-page",
  mixins: [HomebaseMixpanelMixin],
  components: {
    BackToHomeButton,
    BookmarksTable,
    RecommendedLinks,
  },
  created() {
    this.trackAutodeskOnePageHit("Bookmarks");
  },
  data() {
    return {
      currentTabIndex: 0,
      navTabs: [
        {
          title: "Bookmarks",
          component: "bookmarks-table",
        },
        {
          title: "Recommended bookmarks",
          component: "recommended-links"
        },
      ],
    };
  },
  methods: {
    updateNavTab(index) {
      this.currentTabIndex = index;
    },

    isTabActive(index) {
      return index === this.currentTabIndex;
    },
  },
};
</script>

<style scoped src="../../../../static/aone-theme.css"></style>
<style scoped>
.header-wrapper {
  background-color: #fcfcfc;
}
.page-description {
  padding-top: 25px;
  padding-bottom: 20px;
}

/* nav styles */
.nav-wrapper {
  min-height: 300px;
}
.nav-tabs {
  border-bottom: none !important;
}
.nav-item {
  min-width: 150px;
  text-align: center;
}
.nav-item:hover {
  cursor: pointer;
}
.nav-item a {
  color: #000 !important;
}
.nav-item .active {
  font-family: artifaktElementBold;
  color: var(--secondary-color) !important;
}
.nav-item:has(.active) {
  border-bottom: 3px solid var(--secondary-color); /* Updated to match recent edits */
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

@media screen and (min-width: 991px) {
  .nav-item:has(.active) {
    background: white;
  }
}

button {
  all: unset;
  cursor: pointer;
}
</style>


